import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';
import { I18n } from '@aws-amplify/core';
import { ProviderEntityTypeSchema, SyncStatusSchema } from '../../schemas';

// Every value of the API enums (ProviderEntityType, SyncStatus): the provider sync also
// writes Subscription, Invoice, InvoiceItem and PaymentEvent mappings.
const entityTypeOptions = [
    { value: '', label: I18n.get('All Entity Types') },
    ...ProviderEntityTypeSchema.options.map(value => ({ value, label: I18n.get(value) })),
];

const syncStatusOptions = [
    { value: '', label: I18n.get('All Sync Statuses') },
    ...SyncStatusSchema.options.map(value => ({ value, label: I18n.get(value) })),
];

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="entityType"
                label={I18n.get('Entity Type')}
                data={entityTypeOptions}
                component={FormikRadioGroup}
                my="md"
            />
            <Field
                name="syncStatus"
                label={I18n.get('Sync Status')}
                data={syncStatusOptions}
                component={FormikRadioGroup}
                my="md"
            />
        </>
    );
};
